import { isBase64Encoded } from 'core/utils';

/**
 * @description MemberPriceBadge implementation: "Members pay X - Log in to unlock" badge for guests.
 * Opens the sign in modal; after login the page is reloaded and the member price is displayed as a regular price.
 * @param Widget Base widget for extending
 * @returns MemberPriceBadge widget
 */
function MemberPriceBadgeClassCreator(Widget: import('widgets/Widget').TWidget) {
    /**
     * @class MemberPriceBadge
     * @augments Widget
     * @property {string} data-modal-url - sign in modal URL (base64 encoded)
     * @property {string} data-modal-title - sign in modal title
     */
    class MemberPriceBadge extends Widget {
        prefs() {
            return {
                modalUrl: '',
                modalTitle: '',
                ...super.prefs()
            };
        }

        /**
         * @description Opens sign in modal
         */
        handleClick(): void {
            const modalUrl = this.prefs().modalUrl;

            this.eventBus().emit('signInToBuyModal.show', {
                url: isBase64Encoded(modalUrl) ? atob(modalUrl) : modalUrl,
                headerText: this.prefs().modalTitle,
                wrapperClasses: 'm-sign_in_to_buy',
                pageLoadAction: ''
            });
        }
    }

    return MemberPriceBadge;
}

export type TMemberPriceBadge = ReturnType<typeof MemberPriceBadgeClassCreator>;

export type TMemberPriceBadgeInstance = InstanceType<TMemberPriceBadge>;

export default MemberPriceBadgeClassCreator;
